import { FC } from 'react';

import { GlobalNotificationContext } from 'src/contexts/GlobalNotificationContext';
import ContextualNotifications from 'src/elements/ContextualNotifications';
import { INotificationDisplay } from 'src/elements/Notifications';

const GlobalNotifications: FC<INotificationDisplay> = (props) =>
  ContextualNotifications(props, GlobalNotificationContext);

export default GlobalNotifications;
